/* =========================================================
   PRODUCT ACCORDIONS
========================================================= */

(function () {

  'use strict';


  /* =========================================================
     INITIALIZE
  ========================================================= */
  
  function initProductAccordions(section) {

    if (!section) {
      return;
    }


    /*
     * Prevent duplicate initialization when Shopify
     * reloads a section inside the Theme Editor.
     */

    if (section.dataset.accordionsInitialized === 'true') {
      return;
    }

    section.dataset.accordionsInitialized = 'true';


    const items = section.querySelectorAll(
      '.product-accordion'
    );


    items.forEach(function (item) {

      const trigger = item.querySelector(
        '.product-accordion__trigger'
      );

      const content = item.querySelector(
        '.product-accordion__content'
      );


      if (!trigger || !content) {
        return;
      }


      trigger.addEventListener(
        'click',
        function () {

          const isOpen =
            item.classList.contains('is-open');


          if (isOpen) {

            closeAccordion(item);

          } else {

            openAccordion(item);

          }

        }
      );

    });

  }


  /* =========================================================
     OPEN ACCORDION
  ========================================================= */

  function openAccordion(item) {

    const trigger = item.querySelector(
      '.product-accordion__trigger'
    );

    const content = item.querySelector(
      '.product-accordion__content'
    );


    if (!trigger || !content) {
      return;
    }


    item.classList.add('is-open');

    trigger.setAttribute(
      'aria-expanded',
      'true'
    );


    /*
     * Remove hidden before measuring.
     */

    content.hidden = false;


    /*
     * Start from zero height.
     */

    content.style.height = '0px';


    /*
     * Force browser to calculate the new height.
     */

    requestAnimationFrame(function () {

      content.style.height =
        content.scrollHeight + 'px';

    });


    /*
     * After animation, allow the content to
     * naturally resize if its content changes.
     */

    const handleTransitionEnd = function (event) {

      if (event.propertyName !== 'height') {
        return;
      }


      if (item.classList.contains('is-open')) {

        content.style.height = 'auto';

      }


      content.removeEventListener(
        'transitionend',
        handleTransitionEnd
      );

    };


    content.addEventListener(
      'transitionend',
      handleTransitionEnd
    );

  }


  /* =========================================================
     CLOSE ACCORDION
  ========================================================= */

  function closeAccordion(item) {

    const trigger = item.querySelector(
      '.product-accordion__trigger'
    );

    const content = item.querySelector(
      '.product-accordion__content'
    );


    if (!trigger || !content) {
      return;
    }


    /*
     * If height is currently auto,
     * convert it to a real pixel value first.
     */

    content.style.height =
      content.scrollHeight + 'px';


    /*
     * Give browser one frame to register
     * current height before collapsing.
     */

    requestAnimationFrame(function () {

      content.style.height = '0px';

    });


    item.classList.remove('is-open');


    trigger.setAttribute(
      'aria-expanded',
      'false'
    );


    const handleTransitionEnd = function (event) {

      if (event.propertyName !== 'height') {
        return;
      }


      if (!item.classList.contains('is-open')) {

        content.hidden = true;

      }


      content.removeEventListener(
        'transitionend',
        handleTransitionEnd
      );

    };


    content.addEventListener(
      'transitionend',
      handleTransitionEnd
    );

  }


  /* =========================================================
     INITIALIZE ALL SECTIONS
  ========================================================= */

  function initAllProductAccordions() {

    const sections =
      document.querySelectorAll(
        '.product-accordions-section'
      );


    sections.forEach(function (section) {

      initProductAccordions(section);

    });

  }


  /* =========================================================
     DOCUMENT READY
  ========================================================= */

  if (
    document.readyState === 'loading'
  ) {

    document.addEventListener(
      'DOMContentLoaded',
      initAllProductAccordions
    );

  } else {

    initAllProductAccordions();

  }


  /* =========================================================
     SHOPIFY THEME EDITOR
  ========================================================= */

  document.addEventListener(
    'shopify:section:load',
    function (event) {

      const section =
        event.target.querySelector
          ? event.target.querySelector(
              '.product-accordions-section'
            )
          : null;


      if (section) {

        initProductAccordions(section);

      }

    }
  );


})();

document.addEventListener('DOMContentLoaded', function () {
  const popup = document.getElementById('fop');
  if (!popup) return;

  // Strictly ensure popup only runs on the home page
  const isHomePage = window.location.pathname === '/' || 
                     window.location.pathname === '' || 
                     document.body.classList.contains('index') ||
                     document.body.classList.contains('template-index');
  if (!isHomePage) return;

  try {
    // If the user has already successfully submitted the form, do not show again.
    if (localStorage.getItem('fop_submitted') === 'true') {
      // If we are currently on the page immediately after submitting (to see the discount code), 
      // the inline script in liquid will trigger the popup anyway. This return stops the *timer*.
      return;
    }
    // If the user closed it this session, do not show again.
    if (sessionStorage.getItem('fopClosed') === 'true') return;
  } catch (e) {}

  const closeButton = popup.querySelector('.fop-close');

  function openFop() {
    popup.classList.add('open');
    popup.setAttribute(
      'aria-hidden',
      'false'
    );
    document.documentElement.classList.add(
      'fop-active'
    );
    document.body.classList.add(
      'fop-active'
    );
  }

  function closeFop() {
    popup.classList.remove('open');
    popup.setAttribute(
      'aria-hidden',
      'true'
    );
    document.documentElement.classList.remove(
      'fop-active'
    );
    document.body.classList.remove(
      'fop-active'
    );
    try {
      sessionStorage.setItem(
        'fopClosed',
        'true'
      );
    } catch (e) {}
  }

  if (closeButton) {
    closeButton.addEventListener(
      'click',
      closeFop
    );
  }

  popup.addEventListener(
    'click',
    function (event) {
      if (event.target === popup) {
        closeFop();
      }
    }
  );

  document.addEventListener(
    'keydown',
    function (event) {
      if (
        event.key === 'Escape' &&
        popup.classList.contains('open')
      ) {
        closeFop();
      }
    }
  );

  // Open the 15% off launch offer popup on first loading of the page
  setTimeout(function () {
    openFop();
  }, 800);
});


(function(){
  /* ==========================================================================
      HEADER TOTAL HEIGHT MEASUREMENT
   ========================================================================== */
  function updateHeaderTotalHeight() {
    const headerGroups = document.querySelectorAll('.shopify-section-group-header-group');
    let total = 0;
    headerGroups.forEach(el => {
      total += el.offsetHeight;
    });
    if (total > 0) {
      document.documentElement.style.setProperty('--header-total-height', `${total}px`);
    }
  }
  updateHeaderTotalHeight();
  window.addEventListener('resize', updateHeaderTotalHeight, { passive: true });
  window.addEventListener('orientationchange', updateHeaderTotalHeight, { passive: true });
  document.addEventListener('shopify:section:load', updateHeaderTotalHeight);

 /* ==========================================================================
     HERO SLIDER
  ========================================================================== */

  const sliders = document.querySelectorAll('.custom-hero-slider');
  
  sliders.forEach(slider => {
    const container = slider.querySelector('.slider-container');
    const slides = slider.querySelectorAll('.slide');
    const cursor = slider.querySelector('.custom-slider-cursor');
    const polyline = slider.querySelector('.cursor-polyline');
    const progressCircle = slider.querySelector('.progress-ring__circle');
    const dots = slider.querySelectorAll('.slider-dot');
    const actionBtns = slider.querySelectorAll('.action-btn');
    
    if (slides.length <= 1) return;
    
    // Setup Infinite Loop Clones
    const firstClone = slides[0].cloneNode(true);
    const lastClone = slides[slides.length - 1].cloneNode(true);
    
    firstClone.classList.add('slide-clone');
    lastClone.classList.add('slide-clone');
    
    container.appendChild(firstClone);
    container.insertBefore(lastClone, slides[0]);
    
    let currentIndex = 1;
    let isTransitioning = false;
    
    // Start at actual first slide (index 1) without transition
    container.style.transition = 'none';
    container.style.transform = `translateX(-100%)`;
    const isAutoplay = slider.dataset.autoplay === 'true';
    const autoplaySpeed = parseInt(slider.dataset.speed) || 5000;
    let autoplayTimer;
    let startTime;
    let progressAnim;
    let isLeft = false;
    
    // Custom cursor logic
    if (cursor) {
      slider.addEventListener('mousemove', (e) => {
        cursor.style.transform = `translate(${e.clientX - 25}px, ${e.clientY - 25}px)`;
        
        const rect = slider.getBoundingClientRect();
        const x = e.clientX - rect.left;
        
        if (x < rect.width / 2) {
          isLeft = true;
          polyline.setAttribute('points', '15 18 9 12 15 6');
        } else {
          isLeft = false;
          polyline.setAttribute('points', '9 18 15 12 9 6');
        }
      });
      
      slider.addEventListener('click', (e) => {
        // Prevent slide change if clicking a button or dot
        if(e.target.closest('.action-btn') || e.target.closest('.slider-dot')) return;
        
        if (isLeft) {
          prevSlide();
        } else {
          nextSlide();
        }
        resetAutoplay();
      });

      // Restore normal cursor over buttons
      const restoreCursorElements = slider.querySelectorAll('.action-btn, .slider-dot');
      restoreCursorElements.forEach(el => {
        el.addEventListener('mouseenter', () => { cursor.style.display = 'none'; });
        el.addEventListener('mouseleave', () => { cursor.style.display = 'flex'; });
      });
    }

    // Touch swipe navigation for mobile
    let touchStartX = 0;
    let touchStartY = 0;
    slider.addEventListener('touchstart', (e) => {
      if (e.touches.length === 1) {
        touchStartX = e.touches[0].clientX;
        touchStartY = e.touches[0].clientY;
      }
    }, { passive: true });

    slider.addEventListener('touchend', (e) => {
      if (e.changedTouches.length === 1) {
        const touchEndX = e.changedTouches[0].clientX;
        const touchEndY = e.changedTouches[0].clientY;
        const diffX = touchEndX - touchStartX;
        const diffY = touchEndY - touchStartY;
        if (Math.abs(diffX) > Math.abs(diffY) && Math.abs(diffX) > 40) {
          if (diffX < 0) {
            nextSlide();
          } else {
            prevSlide();
          }
          resetAutoplay();
        }
      }
    }, { passive: true });
    
    function goToSlide(index) {
      if (isTransitioning) return;
      isTransitioning = true;
      
      currentIndex = index;
      container.style.transition = 'transform 0.5s ease-in-out';
      container.style.transform = `translateX(-${currentIndex * 100}%)`;
      
      let dotIndex = currentIndex - 1;
      if (currentIndex === 0) dotIndex = slides.length - 1;
      if (currentIndex === slides.length + 1) dotIndex = 0;
      
      dots.forEach((dot, i) => {
        dot.classList.toggle('active', i === dotIndex);
      });
    }
    
    container.addEventListener('transitionend', () => {
      isTransitioning = false;
      if (currentIndex === 0) {
        container.style.transition = 'none';
        currentIndex = slides.length;
        container.style.transform = `translateX(-${currentIndex * 100}%)`;
      }
      if (currentIndex === slides.length + 1) {
        container.style.transition = 'none';
        currentIndex = 1;
        container.style.transform = `translateX(-${currentIndex * 100}%)`;
      }
    });
    
    function nextSlide() { goToSlide(currentIndex + 1); }
    function prevSlide() { goToSlide(currentIndex - 1); }
    
    dots.forEach((dot, i) => {
      dot.addEventListener('click', (e) => {
        e.stopPropagation();
        goToSlide(i + 1);
        resetAutoplay();
      });
    });
    
    function animateProgress() {
      if (!isAutoplay || !progressCircle) return;
      const now = Date.now();
      const elapsed = now - startTime;
      const percent = Math.min(elapsed / autoplaySpeed, 1);
      const circumference = 144; // 2 * Math.PI * 23
      const offset = circumference - (percent * circumference);
      
      progressCircle.style.strokeDashoffset = offset;
      
      if (percent < 1) {
        progressAnim = requestAnimationFrame(animateProgress);
      }
    }

    function startAutoplay() {
      if (isAutoplay) {
        startTime = Date.now();
        autoplayTimer = setInterval(() => {
          nextSlide();
          startTime = Date.now();
        }, autoplaySpeed);
        
        if (progressCircle) {
          cancelAnimationFrame(progressAnim);
          animateProgress();
        }
      }
    }
    
    function resetAutoplay() {
      if (isAutoplay) {
        clearInterval(autoplayTimer);
        cancelAnimationFrame(progressAnim);
        startAutoplay();
      }
    }
    
    startAutoplay();
  });

})();

/* ==========================================================================
   JUDGE.ME REVIEWS: DYNAMIC FILTER FOR LESS THAN 5 STAR REVIEWS
   Ensures any review cards or elements with 1, 2, 3, or 4 stars are
   immediately hidden across all dynamic updates and widget mounts.
   ========================================================================== */
(function() {
  function filterJudgeMeReviews() {
    // 1. Double check and filter in-memory window.jdgm data if available
    try {
      if (window.jdgm && window.jdgm.data) {
        var d = window.jdgm.data;
        if (d.reviewsGridWidget && d.reviewsGridWidget.all_reviews && Array.isArray(d.reviewsGridWidget.all_reviews.reviews)) {
          var initialLen = d.reviewsGridWidget.all_reviews.reviews.length;
          d.reviewsGridWidget.all_reviews.reviews = d.reviewsGridWidget.all_reviews.reviews.filter(function(r) {
            var s = Number(r && (r.rating != null ? r.rating : r.score));
            return isNaN(s) || s >= 5;
          });
          if (d.reviewsGridWidget.all_reviews.reviews.length !== initialLen) {
            d.reviewsGridWidget.all_reviews.total_count = d.reviewsGridWidget.all_reviews.reviews.length;
            d.reviewsGridWidget.number_of_reviews = d.reviewsGridWidget.all_reviews.reviews.length;
            d.reviewsGridWidget.average_rating = 5.0;
          }
        }
      }
    } catch(e) {}

    // 2. Scan and hide DOM elements
    var selectors = [
      '.jdgm-review-card',
      '.jm-grid-item',
      '.jdgm-grid-item',
      '.jdgm-rev',
      '.jdgm-carousel-item',
      '.jdgm-gallery-item',
      '.jdgm-rev-snippet-card'
    ];

    var cards = document.querySelectorAll(selectors.join(', '));
    cards.forEach(function(card) {
      if (card.dataset.jdgmFiltered === 'true') return;

      var shouldHide = false;

      // Check data-score
      var score = card.getAttribute('data-score');
      if (score && ['1', '2', '3', '4'].indexOf(score.trim()) !== -1) {
        shouldHide = true;
      }

      // Check for unfilled or half stars
      if (!shouldHide) {
        var emptyOrHalfStar = card.querySelector(
          '.jm-star-rating__empty, .jm-star-rating__half, .jdgm-star.jdgm--off, .jdgm-star.jdgm--half'
        );
        if (emptyOrHalfStar) {
          shouldHide = true;
        }
      }

      // Check aria-label ratings
      if (!shouldHide) {
        var ratingElem = card.querySelector('.jm-star-rating, .jdgm-rev__rating, [aria-label*="out of"]');
        if (ratingElem) {
          var aria = (ratingElem.getAttribute('aria-label') || '').trim();
          var match = aria.match(/^([0-4](?:\.[0-9]+)?)\s+out\s+of/i);
          if (match && parseFloat(match[1]) < 5) {
            shouldHide = true;
          }
        }
      }

      if (shouldHide) {
        card.style.setProperty('display', 'none', 'important');
        card.setAttribute('aria-hidden', 'true');
      }
      card.dataset.jdgmFiltered = 'true';
    });
  }

  // Run immediately and on events
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', filterJudgeMeReviews);
  } else {
    filterJudgeMeReviews();
  }

  window.addEventListener('load', filterJudgeMeReviews);

  // Observe dynamically inserted elements
  try {
    var observer = new MutationObserver(function() {
      filterJudgeMeReviews();
    });

    observer.observe(document.documentElement, {
      childList: true,
      subtree: true
    });
  } catch(e) {}
})();

